<template>
  <div v-if="itemCount > 1">
    <div class="carousel-nav">
      <p :class="'typography $typography/size:medium $typography/nowrap nowrap' + labelColorClass">
        {{currentIndex + 1}} of {{itemCount}}
      </p>
      <SlideshowController
        :gtm="gtm + ' / prev'"
        :focusOnMount="false"
        :enabled="hasPreviousSlide"
        className="controls__previous-next--overlay"
        label="Previous slide"
        svgName="icon__arrow--20--stroke.svg"
        :svgClass="'controls__link__svg--arrow--180' + svgColorClass"
        @action="$emit('previous')"
      />

      <SlideshowController
        :gtm="gtm + ' / next'"
        :focusOnMount="false"
        :enabled="true"
        className="controls__previous-next--overlay"
        label="Next slide"
        :svgName="svgName"
        :svgClass="svgTypeClass + svgColorClass"
        @action="$emit('next')"
      />
    </div>
  </div>
  <div v-else />
</template>
<script>
  import SlideshowController from "../../slideshows-vue/controllers/controller.vue";
  import KeyCodes from "Utils/key-codes";

  export default {
    components: { SlideshowController },
    props: {
      currentIndex: { type: Number, required: true },
      itemCount: { type: Number, required: true },
      hasLightBackground: { type: Boolean, required: false, default: false },
      gtm: { type: String, required: true }
    },
    mounted: function() {
      document.addEventListener('keydown', this.onKeyDown);
    },
    beforeDestroy: function() {
      document.removeEventListener('keydown', this.onKeyDown);
    },
    methods: {
      onKeyDown(e) {
        switch (e.keyCode) {
          case KeyCodes.LEFT:
            return this.onPrevious();
          case KeyCodes.RIGHT:
            return this.onNext();
        }
      },
      onNext: function() {
        this.$emit("next");
      },
      onPrevious: function() {
        this.$emit("previous");
      }
    },
    computed: {
      svgTypeClass: function() {
        return this.hasNextSlide ? "controls__link__svg--arrow" : "controls__link__svg--restart";
      },
      svgColorClass: function() {
        return this.hasLightBackground ? " has-light-background" : "";
      },
      svgName: function () {
        return this.hasNextSlide ? "icon__arrow--20--stroke.svg" : "icon__restart--20--white.svg";
      },
      labelColorClass: function() {
        return this.hasLightBackground ? " $color/gray:767" : " $color/white"
      },
      hasPreviousSlide: function() {
        return this.currentIndex > 0;
      },
      hasNextSlide: function() {
        return this.currentIndex < this.itemCount - 1;
      }
    },
  }
</script>
